var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, useStrict } from 'mobx';
import Articles from 'modules/Articles/Store';
import Families from 'modules/Families/Store';
import Customers from 'modules/Customers/Store';
import Taxes from 'modules/Taxes/Store';
import Users from 'modules/Users/Store';
import UI from 'modules/UI/Store';
import Branches from 'modules/Branches/Store';
import Stock from 'modules/Stock/Store';
import SettingsInvoice from 'modules/SettingsInvoice/Store';
import Dashboard from 'modules/Dashboard/Store';
import ReportsStore from 'modules/Reports/Store';
import BusinessUnits from 'modules/BusinessUnits/Store';
import OperationLines from 'modules/OperationLines/Store';
import ReceipLayout from 'modules/ReceiptLayouts/Store';
import PassengerCategoriesStore from './modules/PassengerCategories/Store';
import DashboardTicket from 'modules/DashboardTicket/Store';
import LicenseStore from 'modules/Licenses/Store';
import DeviceStore from 'modules/Devices/Store';
import CashDeskTicketStore from 'modules/TempSale/CashDeskTicketStore';
import TempTicketStore from 'modules/TempSale/TempTicketStore';
import StructureStore from './modules/Structures/StructuresStore';
import MoneysStore from './modules/Moneys/MoneysStore';
import StretchesStore from './modules/Stretches/StretchesStore';
import PacketsStore from './modules/Packets/PacketsStore';
import AfiliatesStore from './modules/Afiliates/AfiliatesStore';
import DiscountReasonsStore from './modules/DiscountReasons/DiscountReasonsStore';
import SettingsStore from './modules/Settings/SettingsStore';
import CollaboratorStretchesStore from './modules/CollaboratorStretches/CollaboratorStretchesStore';
import { TempDuePaymentsStore } from './modules/Reports/TempDuePaymentsStore';
import AforoStore from './modules/Aforos/AforoStore';
useStrict(true);
export default class Store {
    constructor() {
        this.inited = false;
        this.initRemainder = () => {
            // console.log('Store - initRemainder()')
            this.articles = new Articles();
            this.families = new Families();
            this.customers = new Customers();
            this.taxes = new Taxes();
            this.branches = new Branches();
            this.stock = new Stock();
            this.settingsInvoice = new SettingsInvoice();
            this.dashboard = new Dashboard();
            this.reports = new ReportsStore();
            this.businessUnits = new BusinessUnits();
            this.operationLines = new OperationLines();
            this.receipLayouts = new ReceipLayout();
            this.passengerCategories = new PassengerCategoriesStore();
            this.stretchesStore = new StretchesStore();
            this.packetsStore = new PacketsStore();
            this.dashboardTicket = new DashboardTicket();
            this.licenses = new LicenseStore();
            this.devices = new DeviceStore();
            this.tempTicketStore = new TempTicketStore(this);
            this.cashDeskTicketStore = new CashDeskTicketStore(this);
            this.structureStore = new StructureStore();
            this.moneysStore = new MoneysStore();
            this.afiliatesStore = new AfiliatesStore();
            this.discountReasonsStore = new DiscountReasonsStore();
            this.settingsStore = new SettingsStore();
            this.collaboratorStretchesStore = new CollaboratorStretchesStore();
            this.setInited(true);
            this.tempDuePaymentsStore = new TempDuePaymentsStore();
            this.aforoStore = new AforoStore();
        };
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.UI = new UI();
            this.users = new Users(this);
            this.users.rehydrate();
            if (this.users.user) {
                this.initRemainder();
            }
            else {
                this.setInited(false);
            }
        });
    }
    setInited(value) {
        this.inited = value;
    }
}
__decorate([
    observable
], Store.prototype, "inited", void 0);
__decorate([
    action
], Store.prototype, "setInited", null);



//////////////////
// WEBPACK FOOTER
// ./src/Store.ts
// module id = 308
// module chunks = 0